import React from 'react'
import _identity from 'lodash/identity'
import InfoTooltip from '../../_library/InfoTooltip'
import DetailAccordion from '../../_library/DetailAccordion'

const RadioGroupField = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  touchedOnBlur = false,
  normalizer = _identity,
  removeSpacing = false,
  groups = [], // [{label: 'Yes', value: 'yes'}, {label: 'Other', value: 'other', component: (<input type='text' />)}]
  classNames = {
    // this is default classNames
    container: '',
    container_item: '',
    component: '',
  },
  extraDiv,
  onClickContainers,
  label,
  helperText,
  tooltipText,
  details,
  detailsTrigger,
  ...props
}) => {
  const setValue = value => {
    setFieldValue(field.name, normalizer(value))
  }
  const onChange = value => {
    setValue(value)
    if (props.onChange) {
      props.onChange(value)
    }
  }
  return (
    <div className="form-group">
      {label && (
        <label className="control-label" htmlFor={field.name}>
          {label}
          {tooltipText && <InfoTooltip text={tooltipText} id={`${field.name}_tooltip`} placement="right" />}
        </label>
      )}
      <RadioGroup
        groups={groups}
        value={field.value}
        name={field.name}
        classNames={classNames}
        removeSpacing={removeSpacing}
        onChange={onChange}
        extraDiv={extraDiv}
        onClickContainers={onClickContainers}
      />
      {helperText && <div className="bottom-helper-text">{helperText}</div>}
      {details && (
        <DetailAccordion className="inline-detail-trigger" trigger={detailsTrigger || 'Learn more'}>
          {details}
        </DetailAccordion>
      )}
    </div>
  )
}

export { RadioGroupField }

export const RadioGroup = ({
  groups,
  value,
  name,
  classNames = { container_item: '', container: '', component: '' },
  removeSpacing,
  onChange = _identity,
  extraDiv = false,
  onClickContainers,
}) => {
  const groupsEls = groups.map((group, idx) => {
    const checked = value === group.value
    if (extraDiv) {
      return (
        <div
          aria-hidden
          className={classNames.container_item}
          key={group.value}
          onClick={onClickContainers ? onClickContainers[idx] : undefined}
        >
          <div className="extra-div">
            <div className="label-check-group">
              <input
                type="radio"
                id={`rg_${group.value}`}
                name={name}
                value={group.value}
                checked={checked}
                onChange={e => onChange(e.target.value)}
              />
              <label htmlFor={`rg_${group.value}`}>
                {!removeSpacing && <span>&ensp;</span>}
                <div className="check" />
                {group.label}
              </label>
            </div>
          </div>
          {checked && !!group.component && <div className={classNames.component}>{group.component}</div>}
        </div>
      )
    }
    return (
      <div className={classNames.container_item} key={group.value}>
        <div className="label-check-group">
          <input
            type="radio"
            id={`rg_${group.value}`}
            name={name}
            value={group.value}
            checked={checked}
            onChange={e => onChange(e.target.value)}
          />
          <label htmlFor={`rg_${group.value}`}>
            <div className="check" />
            {!removeSpacing && <span>&ensp;</span>}
            {group.label}
          </label>
        </div>
        {checked && !!group.component && <div className={classNames.component}>{group.component}</div>}
      </div>
    )
  })

  return <div className={classNames.container}>{groupsEls}</div>
}
